import {Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';

import {IconComponent} from "../../../shared-module/components/icon/icon.component";
import {ButtonComponent} from "../../../shared-module/components/button/button.component";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../../shared-module/services/auth.service";
import RelationContact from "../../../shared-module/model/relation-contact.model";
import Relation from "../../../shared-module/model/relation.model";
import {MobileService} from "../../../shared-module/services/mobile.service";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-choose-relation',
    imports: [
    IconComponent,
    ButtonComponent
],
    templateUrl: './choose-relation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './choose-relation.component.scss'
})
export class ChooseRelationComponent implements OnInit, OnDestroy {
  private readonly router: Router = inject(Router);
  private readonly authService: AuthService = inject(AuthService);
  private readonly mobileService: MobileService = inject(MobileService);
  private readonly route: ActivatedRoute = inject(ActivatedRoute);

  public user: RelationContact | null = null;
  public relations: Relation[] = [];
  public selectedIndex: number = 0;
  private isMobile: boolean = false;
  private subscriptions: Subscription = new Subscription();

  constructor() {
    this.mobileService.isMobile().subscribe((isMobile: boolean) => {
      this.isMobile = isMobile;
    });
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.authService.getUser([
          'relations.subscriptions.products.discount_lines',
          'relations.relation_contacts',
          'relations.tickets',
          'relations.invoices.lines'
      ]).subscribe((user: RelationContact | null) => {
        if (!user) {
          return;
        }
        this.user = user;
        this.relations = user.relations ?? [];

        if (this.relations.length === 1) {
          this.authService.setRelation(this.relations[0] as Relation);
          this.submit();
        }
      })
    );

    this.subscriptions.add(
      this.authService.getActiveRelation().subscribe((relation: Relation | null) => {
        if (relation) {
          this.selectedRelation = relation;
        }
      })
    );
  }

  public submit(): void {
    this.authService.setRelation(this.selectedRelation as Relation);
    if (this.selectedRelation.subscriptions?.length > 0) {
      this.authService.setSelectedSubscription(this.selectedRelation.subscriptions[0]);
    }
    const redirectUrl: string = this.route.snapshot.queryParamMap.get('redirect-url') ?? '/dashboard';
    this.router.navigateByUrl(redirectUrl);
  }

  public get selectedRelation(): Relation {
    return this.relations[this.selectedIndex];
  }

  public set selectedRelation(relation: Relation) {
    this.selectedIndex = this.relations.indexOf(relation);
  }

  public logout(): void {
    this.authService.logout().subscribe(() => {
      this.router.navigate(['/login']);
    });
  }
}
